package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initRunning_installerPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/running_installer.md", FrontMatterElement.EmptyMap))
}

@Page("/faqs_and_info/running-installer")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Running_installerPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("running-installer") }) {
        org.jetbrains.compose.web.dom.Text("Running Installer")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The system may take some time to install your server on a node. This depends heavily on node load.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" “node” refers to the Server Node (the machine where your server will be hosted), not the programming language.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Some servers can take a few minutes or even hours for the installation process to finish successfully. We advise you to wait patiently for the installation to finish and avoid opening tickets unless more than 6 hours have passed since the server was created in the panel.")
    }
}
